import { yupResolver } from '@hookform/resolvers/yup';
import { pageIntroContent } from '@insify/css/classes.module.css';
import { Input } from '@insify/design-system/components';
import defaults from 'lodash.defaults';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import { RichContentWithTooltip } from '../../components/RichContent';
import { WizardLayoutFormWithCommonSection } from '../../components/WizardLayoutForm';

import type { RichContentType } from '../../components/RichContent';

export type HeadcountFormType = {
  headCount: number;
};

export type HeadCountProps = {
  formData: Partial<HeadcountFormType>;
  eventHandlers: {
    onSubmit: (values: HeadcountFormType) => void;
    onBack: () => void;
  };
  content?: RichContentType;
  translations: {
    back: string;
    forward: string;
    validation: {
      integer: string;
      required: string;
      min: string;
      max: string;
    };
  };
  isSubmitting: boolean;
};

export const HeadCount = ({
  formData,
  eventHandlers,
  content,
  translations,
  isSubmitting,
}: HeadCountProps): JSX.Element => {
  const { register, handleSubmit, formState } = useForm<HeadcountFormType>({
    resolver: yupResolver(
      yup.object().shape({
        headCount: yup
          .number()
          .integer(translations.validation.integer)
          .typeError(translations.validation.required)
          .required(translations.validation.required)
          .min(1, translations.validation.min)
          .max(1000, translations.validation.max),
      }),
    ),
    shouldUnregister: true,
    defaultValues: defaults({}, formData, { headCount: 1 }),
    mode: 'onSubmit',
  });

  return (
    <WizardLayoutFormWithCommonSection
      isSubmitting={isSubmitting}
      onBack={eventHandlers.onBack}
      backCopy={translations.back}
      forwardCopy={translations.forward}
      onSubmit={handleSubmit(eventHandlers.onSubmit)}
    >
      <RichContentWithTooltip content={content} className={pageIntroContent} />
      <Input
        {...register('headCount')}
        id='headCount'
        trackingId='headCount'
        inputMode='numeric'
        error={formState.errors.headCount?.message}
        disabled={isSubmitting}
      />
    </WizardLayoutFormWithCommonSection>
  );
};
